export default {"src":"/_next/static/media/SGMEDIA.df8cc620.svg","height":41,"width":34};